import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'
import { RequestTypes } from '../requestTypes'
import { IUserStats, UserStats } from '@core/entities/user'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetUserStats = (
  payload: RequestTypes['getUserStats'],
  options?: UseQueryOptions<IUserStats, RequestErrorType, UserStats>,
) => {
  return useQuery({
    ...profileKeys.getUserStats(payload),
    ...options,
    select: (data) => UserStats.new(data),
  })
}
